import type sanitizeHtml from "sanitize-html";

let sanitizeHtmlPromise: Promise<typeof sanitizeHtml> | undefined;

/**
 * Loads sanitize-html on first use, so it stays out of the public page bundles.
 * @returns The sanitize-html function, shared across callers
 */
export function loadSanitizeHtml() {
    sanitizeHtmlPromise ??= import("sanitize-html").then((module) => module.default);
    return sanitizeHtmlPromise;
}
